import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Table from '../../usables/Table'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Modal from '../../usables/Modal'
import Select from 'react-select'

export default function  Teachers() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [teachers, setTeachers] = useState([])
  const [formData, setFormData] = useState({user_id: ''})
  const [users, setUsers] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: "Mokytojai",
    columns: [
      {
        Header: "Vardas",
        accessor: "person.name"
      },
      {
        Header: "Pavardė",
        accessor: "person.lastname"
      },
      {
        Header: "Telefonas",
        accessor: "person.phone"
      },
      {
        Header: "El. paštas",
        accessor: "person.email"
      },
      {
        Header: "Dalykas",
        accessor: "subject.0.subject_name"
      },
      {
        Header: "Klasė",
        accessor: "student_class.name"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const addTeacher = () => {
    axios.post(process.env.REACT_APP_API + '/teacher', formData, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/teacher', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setTeachers([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/teachers/' + data.id}>Daugiau</Link>
          setTeachers(guardians => [...guardians, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setTeachers([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setTeachers(guardians => [...guardians, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    axios.get(process.env.REACT_APP_API + '/user/list', config)
    .then(res => {
      if(res.status === 200){
        setUsers([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          (data.person !== null & data.teacher === null) && setUsers(subjects => [...subjects, data])
        })
      }
    })
    .catch(err => {
      setUsers([]) //! Pašalinti prieš buildinant
      setUsers(subjects => [...subjects, err.response.data])
      // setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
    <h2>Mokyotojai</h2>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={teachers} />
          : <ClosingAlert type='warning' message='Mokytojų nerasta' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {authUser().roles.admin &&
    <Modal showAddBtn title='Pridėti mokytoją' saveText='Išsaugoti' submitFunction={() => addTeacher()}>
      <div className='pt-5'>
        <label htmlFor="class">Vartotojas</label>
        <Select 
        name='class'
        onChange={(e)=>setFormData({...formData, user_id: e.value})}
        options={
          users.map(user => {
            return ({ value: user.id, label: user.person.name + ' ' +  user.person.lastname})
          })
        } />
      </div>
    </Modal>
}
    </>
  )
}